import React, { useState } from "react";
import { Button, Table, Pagination, Modal, Form } from "react-bootstrap";
import { formatDateToDDMMYYYY, PageSize } from "../../../../Utility/constants";
import "./TeacherDetailsList.css";
import {
  FaCheckCircle,
  FaEye,
  FaEdit,
  FaTrash,
  FaTimesCircle,
  FaFileAlt
} from "react-icons/fa";

const TeacherDetailsList = ({
  data,
  onEdit,
  onView,
  onAddNewTeacher,
  onDelete,
  onClassSubjectView,
  handleSearch,
  handleUpdateStatus,
  showhandleDocumentMaster
}) => {
  const role = localStorage.getItem("Role");
  const [currentPage, setCurrentPage] = useState(1);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [existingStatus, setExistingStatus] = useState("");
  const [selectedteacherId, setSelectedteacherId] = useState(null);

  const [showClassSubjectModal, setShowClassSubjectModal] = useState(false);
  const [selectedClassSubjects, setSelectedClassSubjects] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState("Name");
  const [searchValue, setSearchValue] = useState("");

  // Calculate total pages
  const totalPages = Math.ceil(data.length / PageSize);

  // Calculate current data slice
  const currentData = data.slice(
    (currentPage - 1) * PageSize,
    currentPage * PageSize
  );

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Open the status modal and set the current student ID
  const handleOpenStatusModal = (teacherId, status) => {
    setSelectedteacherId(teacherId);
    setExistingStatus(status || "");
    setShowStatusModal(true);
  };

  // Handle status change
  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  // Submit status change to parent component
  const handleSubmitStatus = () => {
    if (selectedteacherId && selectedStatus) {
      const statusData = {
        teacherId: selectedteacherId,
        status: selectedStatus,
        updatedBy: localStorage.getItem("userID"),
      };
      handleUpdateStatus(statusData);
      setShowStatusModal(false); // Close the modal
    }
  };

  const handleClassSubjectView = (classSubjectDetails) => {
    setSelectedClassSubjects(classSubjectDetails);
    setShowClassSubjectModal(true);
  };

  const handleClearChange = (e) => {
    setSearchCriteria("0");
    setSearchValue("");
    handleSearch();
  };



  return (
    <>
      {/* Add New Button at the top */}

      {(role === "ADMIN" || role === "TEACHER") && (
        <>
          <div className="row align-items-center mb-3">

            {/* Title */}
            <div className="col-md-3">
              <h2 className="mb-0">User Details</h2>
            </div>
            {role === "ADMIN" ?
              <>
                {/* Search dropdown */}
                <div className="col-md-2">
                  <select
                    className="form-control"
                    value={searchCriteria}
                    onChange={(e) => setSearchCriteria(e.target.value)}
                  >
                    <option value="0">Select</option>
                    <option value="name">Name</option>
                    <option value="mobileno">Mobile No</option>
                    <option value="aadhaar">Aadhaar No</option>
                  </select>
                </div>

                {/* Search input */}
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter search value"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                </div>

                {/* Search button */}
                <div className="col-md-1">
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => handleSearch(searchCriteria, searchValue)}
                  >
                    Search
                  </button>
                </div>

                {/* Clear button */}
                <div className="col-md-1">
                  <button
                    className="btn btn-danger w-100"
                    onClick={() => handleClearChange(null, null)}
                  >
                    Clear
                  </button>
                </div>

                {/* Add Student button */}
                <div className="col-md-2 text-end">
                  <Button variant="primary" onClick={onAddNewTeacher}>
                    Add User
                  </Button>
                </div>
              </> : ''}

          </div>
        </>
      )}

      <Table striped bordered hover>
        <thead className="thead-dark">
          <tr>
            <th style={{ width: "40px" }}>#</th>
            <th style={{ width: "220px" }}>User Name</th>
            <th style={{ width: "80px" }}>Gender</th>
            {/* <th>Class, Section, Stream</th> */}
            <th style={{ width: "110px" }}>Date of Birth</th>
            <th style={{ width: "130px" }}>Joining Date</th>
            <th style={{ width: "130px" }}>Aadhaar No</th>
            <th style={{ width: "110px" }}>Role</th>
            <th style={{ width: "120px" }}>Phone</th>
            {/* <th>Address</th> */}
            <th style={{ width: "150px" }}>Password</th>  {/* New header */}
            <th style={{ textAlign: "center", width: "250px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentData.map((item, index) => (
            <tr key={index}>
              <td>{(currentPage - 1) * PageSize + index + 1}</td>
              <td style={{
                whiteSpace: "normal", wordBreak: "breakWord", overflowWrap: "breakWord", maxWidth: "200px"
              }}>{item.fullName}</td>
              <td>{item.gender}</td>
              <td>{formatDateToDDMMYYYY(item.dateOfBirth)}</td>
              <td>{formatDateToDDMMYYYY(item.joiningDate)}</td>
              <td>{item.aadhaarCardNumber}</td>
              <td>{item.classSubjectDetails.some(x => x.isClassTeacher === 1) ? 'Class Teacher' : item.role}</td>
              <td>{item.phone}</td>
              <td>
                {item.password}
              </td>
              <td style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "1px",
                alignItems: "center",
              }}>
                {role === "ADMIN" ?
                  <Button
                    variant={
                      item.status === "APPROVED"
                        ? "success"
                        : item.status === "REJECTED"
                          ? "danger"
                          : "warning"
                    }
                    onClick={() => handleOpenStatusModal(item.id, item.status)}
                    title={
                      item.status === "APPROVED"
                        ? "Approved"
                        : item.status === "REJECTED"
                          ? "Rejected"
                          : "Approve / Reject"
                    }
                  >
                    {item.status === "APPROVED" ? (
                      <FaCheckCircle />
                    ) : item.status === "REJECTED" ? (
                      <FaTimesCircle />
                    ) : (
                      <FaCheckCircle />
                    )}
                  </Button>
                  : ''}

                <Button
                  variant="info"
                  onClick={() => onView(item.id)}
                  title="View Details"
                >
                  <FaEye />
                </Button>

                <Button
                  variant="secondary"
                  onClick={() => showhandleDocumentMaster(item.id)}
                  title="View Documents"
                >
                  <FaFileAlt />
                </Button>

                <Button
                  variant="warning"
                  onClick={() => onEdit(item.id)}
                  title="Edit Details"
                >
                  <FaEdit />
                </Button>
                {role === "ADMIN" ?
                  <Button
                    variant="danger"
                    onClick={() => onDelete(item.id)}
                    title="Delete User"
                  >
                    <FaTrash />
                  </Button> : ''}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      {role === "ADMIN" ?
        <>
          <Pagination className="justify-content-center">
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item
                key={i}
                active={i + 1 === currentPage}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </>
        : ''
      }

      {/* Status Modal */}
      <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Update Student Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="statusSelect">
            <Form.Label>Select Status</Form.Label>
            <Form.Control as="select" onChange={handleStatusChange} value={selectedStatus || existingStatus}>
              <option value="">--Select--</option>
              <option value="APPROVED">Approved</option>
              <option value="REJECTED">Rejected</option>
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmitStatus}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showClassSubjectModal} onHide={() => setShowClassSubjectModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Class Subject Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedClassSubjects.length === 0 ? (
            <p>No class subject details available.</p>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Class</th>
                  <th>Section</th>
                  <th>Stream</th>
                  <th>Subject</th>
                  <th>Is Class Teacher</th>
                </tr>
              </thead>
              <tbody>
                {selectedClassSubjects.map((cs) => (
                  <tr key={cs.id}>
                    <td>{cs.class}</td>
                    <td>{cs.section}</td>
                    <td>{cs.stream}</td>
                    <td>{cs.subject}</td>
                    <td>{cs.isClassTeacher === 1 ? "Yes" : "No"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowClassSubjectModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default TeacherDetailsList;
